import React from 'react';

import Button, { ButtonVariant } from 'components/Button/Button';
import { t } from 'locales/i18n';

interface FormControlsProps {
  isLoading: boolean;
  isDisabled?: boolean;
  shouldShowAddAnother?: boolean;
  onCancel: () => void;
  onBeforeSubmit?: () => void;
  onBeforeAddAnother?: () => void;
}

const FormControls = ({
  isLoading,
  isDisabled = false,
  shouldShowAddAnother = false,
  onCancel,
  onBeforeSubmit,
  onBeforeAddAnother,
}: FormControlsProps) => (
  <div className="flex justify-end space-x-2 pt-4">
    <Button
      variant={ButtonVariant.CANCEL}
      onClick={onCancel}
      type="button"
      disabled={isLoading}
      buttonText={t('Cancel')}
      dataTestId="cancel"
    />
    {shouldShowAddAnother && (
      <Button
        variant={ButtonVariant.TERTIARY}
        onClick={onBeforeAddAnother}
        type="submit"
        disabled={isLoading}
        isLoading={isLoading}
        buttonText={t('Save & Add Another')}
        dataTestId="save&addAnother"
      />
    )}
    <Button
      variant={ButtonVariant.SAVE}
      type="submit"
      onClick={onBeforeSubmit}
      disabled={isLoading || isDisabled}
      isLoading={isLoading}
      buttonText={t('Save')}
      dataTestId="save"
    />
  </div>
);

export default FormControls;
